export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

export const formatDate = (date: string | Date): string => {
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(date))
}

export const formatDateTime = (date: string | Date): string => {
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date))
}

export const formatStatus = (status: string): string => {
  const statusMap: Record<string, string> = {
    SCHEDULED: 'Agendado',
    PENDING: 'Pendente',
    DRAFT: 'Rascunho',
    IN_PROGRESS: 'Em Andamento',
    WAITING_PARTS: 'Aguarda Peças',
    WAITING_APPROVAL: 'Aguarda Aprovação',
    RESOLVED: 'Resolvida',
    COMPLETED: 'Concluída',
    CANCELLED: 'Cancelada',
    INVOICED: 'Faturada',
  }
  return statusMap[status] || status
}


